module.exports = __webpack_public_path__ + "img/tl.410ab234.png";